export const getBackendUrl = () => process.env.REACT_APP_API_BASE_URL;
export const getS3Url = () => process.env.REACT_APP_S3_URL;

export const DEFAULT_ERROR_MESSAGE = '¡Ups! Algo salió mal al procesar tu solicitud. Por favor, inténtalo de nuevo.'
export const FORBIDDEN_ERROR_MESSAGE = 'Usted no tiene permiso para realizar esta acción'
export const SERVER_ERROR_MESSAGE = '¡Ups! Algo salió mal en el servidor. Contacte al administrador o inténtelo más tarde.'